import React, { useEffect, useState } from "react";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Label,
  Input,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Container,
  Button,
} from "reactstrap";
import { showLoading } from "react-global-loading";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import SysUsers from "./SysUsers";
import Roles from "./Roles";
import Designation from "./Designation";
import "../Standards/Standards.scss";
import { getLoggedInUser } from "../../helpers/backend_helper";
import { Toolbar } from "../../components/Common/LegacyGridAdapter";

const SettingsSysSecurity = () => {
  const [companyId, setCompanyId] = useState(0);
  const [activeTab, setactiveTab] = useState(1);
  const [active, setActive] = useState("1");
  const [key, setKey] = useState(0);
  const [newUserRequest, setNewUserRequest] = useState(0);

  useEffect(() => {
    setCompanyId(getLoggedInUser().companyId);
  }, []);

  return (
    <React.Fragment>
      <div className="page-content standards-page piers-page">
        <Container fluid>
          <header className="standards-page__header piers-page-header">
            <div>
              <h1 className="piers-page-title">Users</h1>
              <p>
                Manage user access and application roles across the platform.
              </p>
            </div>
            {activeTab === 1 && (
              <button
                type="button"
                className="standards-page__create"
                data-onboarding-target="team"
                onClick={() => setNewUserRequest((request) => request + 1)}
              >
                <i className="bx bx-plus" /> Add User
              </button>
            )}
          </header>
          <CardBody className="standards-page__body">
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
              <Nav tabs className="standards-page__tabs">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      setactiveTab(1);
                    }}
                  >
                    <span>Users</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {
                      setactiveTab(2);
                    }}
                  >
                    <span>Roles</span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                className="standards-page__tabs-content"
                activeTab={activeTab}
              >
                <TabPane tabId={1}>
                  <SysUsers createRequest={newUserRequest} />
                </TabPane>
                <TabPane tabId={2}>
                  <Roles />
                </TabPane>
              </TabContent>
            </div>
          </CardBody>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SettingsSysSecurity;
